// extracted by mini-css-extract-plugin
export default {"infoFotCont":"InfoFooter_infoFotCont__i-fAE","pref":"InfoFooter_pref__Ogbr5","copy":"InfoFooter_copy__dfAni"};